import entries from "../data/pageSeo.json";

export interface PageSeo {
  title: string;
  description: string;
  noIndex?: boolean;
}

export const PAGE_SEO: Record<string, PageSeo> = entries;
export const SEO_BASE_URL = "https://eridonai.ru";
export const SEO_ALIASES: Record<string, string> = {
  "/landing": "/",
  "/contact": "/contacts",
  "/tariffs": "/pricing",
  "/privacy-policy": "/privacy",
  "/terms": "/offer",
  "/terms-of-service": "/offer",
  "/auth/login": "/auth",
  "/auth/register": "/auth",
  "/auth/signup": "/auth",
  "/auth/forgot": "/auth",
};

export function getPageSeo(path: string) {
  const normalized = path.split(/[?#]/)[0].replace(/\/$/, "") || "/";
  const canonicalPath = SEO_ALIASES[normalized] ?? normalized;
  return { canonicalPath, metadata: PAGE_SEO[canonicalPath] };
}

export function getPageTitle(path: string, title: string) {
  return path === "/" || /ERIDON/i.test(title) ? title : `${title} — ERIDON`;
}

function escapeHtml(value: string) {
  return value.replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  })[character] ?? character);
}

/** Produces crawlable route metadata without executing the client application. */
export function renderPageSeo(html: string, path: string) {
  const { canonicalPath, metadata } = getPageSeo(path);
  if (!metadata) return html;
  const title = escapeHtml(getPageTitle(canonicalPath, metadata.title));
  const description = escapeHtml(metadata.description);
  const url = escapeHtml(`${SEO_BASE_URL}${canonicalPath}`);
  const robots = metadata.noIndex ? "noindex, follow" : "index, follow, max-image-preview:large";
  const tags = [
    `<title data-rh="true">${title}</title>`,
    `<meta data-rh="true" name="description" content="${description}" />`,
    `<link data-rh="true" rel="canonical" href="${url}" />`,
    `<meta data-rh="true" name="robots" content="${robots}" />`,
    `<meta data-rh="true" property="og:title" content="${title}" />`,
    `<meta data-rh="true" property="og:description" content="${description}" />`,
    `<meta data-rh="true" property="og:url" content="${url}" />`,
    `<meta data-rh="true" name="twitter:title" content="${title}" />`,
    `<meta data-rh="true" name="twitter:description" content="${description}" />`,
  ].join("\n    ");
  return html.replace(/<head\b[^>]*>[\s\S]*?<\/head>/i, (head) => head
    .replace(/<title\b[^>]*>[\s\S]*?<\/title>/gi, "")
    .replace(/<meta\b[^>]*>/gi, (tag) => /(?:name|property)\s*=\s*["'](?:description|robots|googlebot|yandex|og:title|og:description|og:url|twitter:title|twitter:description)["']/i.test(tag) ? "" : tag)
    .replace(/<link\b[^>]*\brel\s*=\s*["']canonical["'][^>]*>/gi, "")
    .replace(/<\/head>/i, `    ${tags}\n  </head>`));
}